export default __webpack_public_path__ + "20a16390ccac29aa3c54e56d97e9bbce.png";